import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { KnTopbarComponent } from './components/kn-topbar.component';
import { CmSharedModule } from '../../shared/shared-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DiscrepanciesTableComponent } from './components/widgets/discrepancies/discrepancies-table.component';
import { WidgetDiscrepanciesComponent } from './components/widgets/discrepancies/widget-discrepancies.component';
import { CurrencyPipe, DatePipe, DecimalPipe, PercentPipe } from '@angular/common';
import { DemandPartnerAutocompleteComponent } from './components/demand-partner-autocomplete.component';
import { DemandPartnerAutocompleteChipsComponent } from './components/demand-partner-autocomplete-chips.component';
import { UserAutocompleteComponent } from './components/user-autocomplete.component';
import { WidgetDiscrepanciesSettingsDialogComponent } from './components/widgets/discrepancies/widget-discrepancies-settings-dialog.component';
import { ReportBuilderPredicatesComponent } from './components/report-builder-predicates.component';
import { WidgetAlertsComponent } from './components/widgets/alerts/widget-alerts.component';
import { WidgetStatusChangeComponent } from './components/widgets/alerts/widget-status-change.component';
import { WidgetAlertsSettingsDialogComponent } from './components/widgets/alerts/widget-alerts-settings-dialog.component';
import { WidgetAlertsTableComponent } from './components/widgets/alerts/widget-alerts-table.component';
import { WidgetDailyMetricsChartComponent } from './components/widgets/widget-daily-metrics-chart.component';
import { DailyMetricsChartComponent } from './components/charts/daily-metrics-chart.component';
import { BidderMetricsChartComponent } from './components/charts/bidder-metrics-chart.component';
import {
  CmWidgetActionsComponent,
  CmWidgetComponent,
  CmWidgetContentComponent,
  CmWidgetFooterComponent,
  CmWidgetHeaderCenter,
  CmWidgetTitleComponent
} from './components/widgets/cm-widget.component';
import { AdUnitStatusChangeTableComponent } from './components/widgets/status/ad-unit-status-change-table.component';
import { WidgetAdUnitStatusChangeSettingsDialogComponent } from './components/widgets/status/widget-ad-unit-status-change-settings-dialog.component';
import { WidgetAdUnitStatusChangeComponent } from './components/widgets/status/widget-ad-unit-status-change.component';
import { PublisherMultiselectSearchComponent } from './components/publisher-multiselect-search.component';
import { PublisherMultiselectSearchDropdownComponent } from './components/publisher-multiselect-search-dropdown.component';
import { HourlyMetricsChartComponent } from './components/charts/hourly-metrics-chart.component';
import { WidgetMainTableComponent } from './components/widgets/main-table/widget-main-table.component';
import { KnMainTableComponent } from './components/widgets/main-table/kn-main-table.component';
import { KnMainTableDiscrepanciesDialogComponent } from './components/widgets/main-table/kn-main-table-discrepancies-dialog.component';
import { KnMainTableMetricsChartDialogComponent } from './components/widgets/main-table/kn-main-table-metrics-chart-dialog.component';
import { ReportMetricMultiselectSearchComponent } from './components/report-metric-multiselect-search.component';
import { ReportMetricMultiselectSearchDropdownComponent } from './components/report-metric-multiselect-search-dropdown.component';
import { ReportMetricSingleSelectDropdownComponent } from './components/report-metric-singleselect-dropdown.component';

import {
  CmCardComponent,
  CmCardContentComponent,
  CmCardFooterComponent,
  CmCardHeaderComponent,
  CmCardTitleComponent
} from './components/layout/cm-card.component';
import { PublisherAutocompleteChipsComponent } from './components/publisher-autocomplete-chips.component';
import { AuthModule } from '../../shared/auth-module';
import { HasPermissionDirective } from '../../shared/auth/rbac/has-permission.directive';
import { AdUnitBdrBadgeComponent } from './components/ad-unit-bdr-badge.component';
import { UnitNameTrim } from './components/unit-name-trim.pipe';
import { DpConnectorsService } from './services/dp-connectors.service';
import { ContentManagementService } from './services/content-management.service';
import { AdUnitDomainListDialogComponent } from './components/ad-unit-domain-list-dialog.component';
import { UnitHbIdForDpDialogComponent } from './components/hb-id/unit-hb-id-for-dp-dialog.component';
import { DpAutocreationAppnexusDialogComponent } from './components/hb-id/dp-autocreation-appnexus-dialog.component';
import { DpAutocreationPubmaticComponent } from './components/hb-id/dp-autocreation-pubmatic-dialog.component';
import { PublisherMultiselectSearchDialogComponent } from './components/publisher-multiselect-search-dialog.component';
import { DpAutocreationRubiconDialogComponent } from './components/hb-id/dp-autocreation-rubicon-dialog.component';
import { WidgetDailyMetricsChartSettingsDialogComponent } from './components/widgets/widget-daily-metrics-chart-settings-dialog.component';
import { PublisherNotesComponent } from './components/publisher-notes.component';
import { AdUnitNotesComponent } from './components/ad-unit-notes.component';
import { PublisherUnitNotesDialogComponent } from './components/publisher-unit-notes-dialog.component';
import { AdUnitFlagComponent } from './components/ad-unit-flag.component';
import { DpSiteDetailsDialogComponent } from './components/kn-dp-site-details-dialog.component';
import { TeamSupportDialogComponent } from './components/team-support-dialog.component';
import { StatusChangeEmailDialogComponent } from './components/status-change-email-dialog.component';
import {CompanyAutocompleteComponent} from './components/company-autocomplete.component';

@NgModule({
  imports: [
    CmSharedModule,
    FormsModule,
    ReactiveFormsModule,
    AuthModule,
    RouterModule,
  ],
  declarations: [
    KnTopbarComponent,
    DiscrepanciesTableComponent,
    WidgetDiscrepanciesComponent,

    // autocomplete
    DemandPartnerAutocompleteChipsComponent,
    DemandPartnerAutocompleteComponent,
    UserAutocompleteComponent,
    PublisherAutocompleteChipsComponent,
    PublisherMultiselectSearchComponent,
    PublisherMultiselectSearchDropdownComponent,
    ReportMetricMultiselectSearchComponent,
    AdUnitDomainListDialogComponent,
    TeamSupportDialogComponent,
    DpSiteDetailsDialogComponent,
    ReportMetricMultiselectSearchDropdownComponent,
    ReportMetricSingleSelectDropdownComponent,
    PublisherMultiselectSearchDialogComponent,

    WidgetDiscrepanciesSettingsDialogComponent,
    ReportBuilderPredicatesComponent,
    WidgetAlertsComponent,
    WidgetStatusChangeComponent,
    WidgetAlertsSettingsDialogComponent,
    WidgetAlertsTableComponent,
    DailyMetricsChartComponent,
    BidderMetricsChartComponent,
    HourlyMetricsChartComponent,
    WidgetDailyMetricsChartComponent,
    CmWidgetComponent,
    CmWidgetContentComponent,
    CmWidgetActionsComponent,
    CmWidgetTitleComponent,
    CmWidgetFooterComponent,
    CmWidgetHeaderCenter,
    WidgetAdUnitStatusChangeSettingsDialogComponent,
    WidgetAdUnitStatusChangeComponent,
    WidgetMainTableComponent,
    KnMainTableComponent,
    KnMainTableDiscrepanciesDialogComponent,
    KnMainTableMetricsChartDialogComponent,
    AdUnitStatusChangeTableComponent,
    StatusChangeEmailDialogComponent,

    // cm card
    CmCardComponent,
    CmCardHeaderComponent,
    CmCardTitleComponent,
    CmCardContentComponent,
    CmCardFooterComponent,

    // hbid
    UnitHbIdForDpDialogComponent,
    DpAutocreationAppnexusDialogComponent,
    DpAutocreationPubmaticComponent,
    DpAutocreationRubiconDialogComponent,

    WidgetDailyMetricsChartSettingsDialogComponent,

    // other
    AdUnitBdrBadgeComponent,
    UnitNameTrim,
    PublisherNotesComponent,
    AdUnitNotesComponent,
    PublisherUnitNotesDialogComponent,
    AdUnitFlagComponent,
    CompanyAutocompleteComponent

  ],
  providers: [
    DpConnectorsService,
    ContentManagementService,
    PercentPipe,
    CurrencyPipe,
    DatePipe,
    DecimalPipe
  ],
  exports: [
    // general
    KnTopbarComponent,
    CmSharedModule,
    FormsModule,
    ReactiveFormsModule,
    KnMainTableComponent,
    KnMainTableDiscrepanciesDialogComponent,
    KnMainTableMetricsChartDialogComponent,
    AdUnitStatusChangeTableComponent,
    AuthModule,

    // autocomplete
    PublisherMultiselectSearchComponent,
    PublisherMultiselectSearchDropdownComponent,
    PublisherMultiselectSearchDialogComponent,
    ReportMetricMultiselectSearchComponent,
    ReportMetricMultiselectSearchDropdownComponent,
    ReportMetricSingleSelectDropdownComponent,
    PublisherAutocompleteChipsComponent,
    DemandPartnerAutocompleteComponent,
    DemandPartnerAutocompleteChipsComponent,
    UserAutocompleteComponent,

    DiscrepanciesTableComponent,
    WidgetDiscrepanciesComponent,
    ReportBuilderPredicatesComponent,
    WidgetAlertsComponent,
    WidgetStatusChangeComponent,
    WidgetDailyMetricsChartComponent,
    DailyMetricsChartComponent,
    BidderMetricsChartComponent,
    HourlyMetricsChartComponent,
    AdUnitDomainListDialogComponent,
    TeamSupportDialogComponent,
    DpSiteDetailsDialogComponent,

    // widgets
    CmWidgetComponent,
    CmWidgetContentComponent,
    CmWidgetActionsComponent,
    CmWidgetTitleComponent,
    CmWidgetHeaderCenter,
    CmWidgetFooterComponent,
    WidgetAdUnitStatusChangeSettingsDialogComponent,
    WidgetAdUnitStatusChangeComponent,
    WidgetMainTableComponent,

    CmCardComponent,
    CmCardHeaderComponent,
    CmCardContentComponent,
    CmCardFooterComponent,
    CmCardTitleComponent,
    HasPermissionDirective,

    AdUnitBdrBadgeComponent,
    UnitNameTrim,

    // hb id
    UnitHbIdForDpDialogComponent,
    DpAutocreationAppnexusDialogComponent,
    DpAutocreationRubiconDialogComponent,
    DpAutocreationPubmaticComponent,

    WidgetDailyMetricsChartSettingsDialogComponent,

    // other
    PublisherNotesComponent,
    PublisherUnitNotesDialogComponent,
    AdUnitNotesComponent,
    AdUnitFlagComponent,
    CompanyAutocompleteComponent
  ],
  entryComponents: [
    WidgetDiscrepanciesSettingsDialogComponent,
    WidgetAlertsSettingsDialogComponent,
    WidgetAdUnitStatusChangeSettingsDialogComponent,
    KnMainTableDiscrepanciesDialogComponent,
    KnMainTableMetricsChartDialogComponent,
    AdUnitDomainListDialogComponent,
    TeamSupportDialogComponent,
    DpSiteDetailsDialogComponent,
    UnitHbIdForDpDialogComponent,
    DpAutocreationAppnexusDialogComponent,
    DpAutocreationRubiconDialogComponent,
    WidgetDailyMetricsChartSettingsDialogComponent,
    DpAutocreationPubmaticComponent,
    PublisherMultiselectSearchDialogComponent,
    PublisherUnitNotesDialogComponent,
    StatusChangeEmailDialogComponent,

  ]
})
export class KitchenSharedModule {
}
